import { render, staticRenderFns } from "./MessengerReceiptListTable.vue?vue&type=template&id=180a4fa8&scoped=true"
import script from "./MessengerReceiptListTable.vue?vue&type=script&lang=js"
export * from "./MessengerReceiptListTable.vue?vue&type=script&lang=js"
import style0 from "./MessengerReceiptListTable.vue?vue&type=style&index=0&id=180a4fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a4fa8",
  null
  
)

export default component.exports